import React, { FC } from 'react';
import { InlineNotification } from '../inline-notification';

const NOTIFICATION_TYPES_MAP = {
  green: 'success',
  red: 'error',
  blue: 'info',
  yellow: 'warning',
};

export type NotificationType = 'green' | 'red' | 'blue' | 'yellow';

export interface Props {
  content?: string;
  id: string;
  level?: NotificationType;
  onClose: (id: string) => void;
  title?: string;
}

export const SystemNotification: FC<Props> = ({ content, id, level, onClose, title }) => {
  const handleOnClose = (): void => {
    onClose(id);
  };

  const getNotificationType = (type: NotificationType): string => {
    return NOTIFICATION_TYPES_MAP[type];
  };

  return (
    <InlineNotification type={level && getNotificationType(level)} closeAction={handleOnClose}>
      {title && <span className="notification-title">{title}</span>}{' '}
      {content && (
        <span
          dangerouslySetInnerHTML={{ __html: content }}
          className="notification-body"
          aria-label="notification-body"
        />
      )}
    </InlineNotification>
  );
};
